import { connect } from 'react-redux'
import StationUserGoinZonePane from '../../components/station-user/view/StationUserGoinZonePane'
import {
  IStoreState,
  IStationUserZoneObject,
  IStationUserGoinZoneObject,
  StationUserGoinZoneShapeType,
  StationUserGeoJsonShapeType
} from '../../types'
import { enableButtons } from 'src/state/actions/goinzones'
import { getGoinzones, createGoinzones, removeGoinzone, updateGoinzone } from 'src/state/actions/station-user'
const getShape = (
  goinzone: IStationUserGoinZoneObject
): {
  shape: any
  shapeType: StationUserGeoJsonShapeType
} => {
  let shape: any = goinzone.geojson
  let shapeType: any = goinzone.type
  switch (goinzone.type) {
    case StationUserGoinZoneShapeType.SHAPE_POLYGON:
    case StationUserGeoJsonShapeType.SHAPE_POLYGON:
      shape = {
        type: StationUserGeoJsonShapeType.SHAPE_MULTIPOLYGON,
        coordinates: [goinzone.geojson]
      }
      shapeType = StationUserGoinZoneShapeType.SHAPE_MULTIPOLYGON
      break
    case StationUserGoinZoneShapeType.SHAPE_MULTIPOLYGON:
    case StationUserGeoJsonShapeType.SHAPE_MULTIPOLYGON:
      shape = {
        type: StationUserGeoJsonShapeType.SHAPE_MULTIPOLYGON,
        coordinates: goinzone.geojson
      }
      shapeType = StationUserGoinZoneShapeType.SHAPE_MULTIPOLYGON
      break
  }
  return {
    shape,
    shapeType
  }
}

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  const stationUserId = ownProps.match.params.id
  return {
    zones: state.goinzones.items,
    orgId: state.organizations.currentOrgId,
    viewMode: ownProps.viewMode,
    stationUserId,
    routeProps: ownProps
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    addGoinZone: (goinzone: IStationUserGoinZoneObject, orgId: string, stationUserId: string) => {
      return new Promise((approve, reject) => {
        //TODO fix this later
        const { shape, shapeType } = getShape(goinzone)
        const zoneObj: IStationUserZoneObject = {
          stationUserId,
          name: goinzone.name,
          color: goinzone.color,
          type: goinzone.zoneType,
          shapeType,
          description: goinzone.description,
          address: goinzone.address,
          radius: goinzone.radius,
          center: {
            type: StationUserGeoJsonShapeType.SHAPE_POINT,
            coordinates: [goinzone.coordinates.lng, goinzone.coordinates.lat]
          },
          shape
        }
        dispatch(createGoinzones(zoneObj)).then(() => {
          dispatch(getGoinzones(stationUserId)).then(() => {
            approve()
          })
        })
      }) //
    },
    removeGoinZone: (zoneId: string, stationUserId: string) => {
      return new Promise((approve, reject) => {
        dispatch(removeGoinzone(zoneId)).then(() => {
          dispatch(getGoinzones(stationUserId)).then(() => {
            approve()
          })
        })
      })
    },
    updateGoinZone: (goinzone: IStationUserGoinZoneObject, stationUserId: string) => {
      const { shape, shapeType } = getShape(goinzone)
      const zoneObj: IStationUserZoneObject = {
        id: goinzone.id,
        stationUserId,
        name: goinzone.name,
        address: goinzone.address,
        description: goinzone.description,
        color: goinzone.color,
        type: goinzone.zoneType,
        shapeType,
        radius: goinzone.radius,
        center: {
          type: StationUserGeoJsonShapeType.SHAPE_POINT,
          coordinates: [goinzone.coordinates.lng, goinzone.coordinates.lat]
        },
        shape
      }
      return new Promise((approve, reject) => {
        dispatch(updateGoinzone(zoneObj)).then(() => {
          dispatch(getGoinzones(stationUserId)).then(() => {
            approve()
          })
        })
      })
    },
    getGoinzones: (serviceId: string) => {
      return dispatch(getGoinzones(serviceId))
    },
    enableButtons: (flag: boolean) => {
      return dispatch(enableButtons(flag))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StationUserGoinZonePane)



// WEBPACK FOOTER //
// ./src/containers/station-user/StationUserGoinZonePane.ts